<!-- prettier-ignore -->

<ion-header (click)="dismissModal()">
    <ion-toolbar class="legal-texts-toolbar">
        <ion-title>{{ title }}</ion-title>
        <ion-buttons slot="end">
            <ion-icon name="close"></ion-icon>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content class="legal-texts-content" >
    <div #legalTextEl class="legal-texts" [innerHTML]="legalText"></div>
</ion-content>